import { IBondGrossReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_GROSS_YIELD_LINKED';

export type IReportGrossYieldLinkedItem = IBondGrossReport & { __isSelected: boolean };
